import React from 'react'
import { IconProps } from '../types'

export default function CurveDecorativeIcon({
    className,
    size = 95,
    color = 'black',
    strokeWidth = 2,
    strokeOpacity = 0.06,
    ...props
}: IconProps) {
    return (
        <svg
            width={size}
            height={Math.round((Number(size) * 32) / 95)}
            viewBox="0 0 95 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            {...props}
        >
            <path
                d="M0.998063 15.2294C0.998063 15.2294 9.76378 6.19743 17.35 4.35714C27.4287 1.91224 34.6694 16.038 34.019 23.0306C33.3685 30.0231 26.5386 30.6736 22.1479 30.0231C17.7572 29.3727 14.4236 23.9821 15.9684 17.9081C17.5133 11.8342 27.8532 0.417013 42.2729 1.57357C56.6925 2.73014 63.6536 10.5899 58.0323 18.6656C55.9736 21.6232 53.2924 23.125 50.492 23.9821C47.6915 24.8392 41.8967 23.2927 42.3686 17.4093C42.8405 11.5258 54.9115 1.66698 65.2312 3.41501C74.4739 4.98059 83.1507 12.0253 82.5699 19.2669C81.989 26.5084 75.1468 25.9596 73.6765 25.8417C72.2063 25.7237 68.2368 24.8356 67.8716 19.4548C67.5064 14.074 71.6476 -2.78895 93.7616 1.77482"
                stroke={color}
                strokeOpacity={strokeOpacity}
                strokeWidth={strokeWidth}
                strokeLinecap="round"
            />
        </svg>
    )
}
